// eslint-disable-next-line no-unused-vars
import request from '@/service/http'


export function searchInit (data) {
  return request({
    url: '/api/trainClass/searchInit',
    method: 'post',
    data,
  })
}

export function searchList (data) {
  return request({
    url: '/api/trainClass/searchList',
    method: 'post',
    data,
  })
}

export function searchTeacherClassList (data) {
    return request({
      url: '/api/trainClass/teacherClassList',
      method: 'post',
      data,
    })
}

export function classAddInit (data) {
  return request({
    url: '/api/trainClass/classAddInit',
    method: 'post',
    data,
  })
}


export function saveOrUpdateClass (data) {
    return request({
      url: '/api/trainClass/saveOrUpdateClass',
      method: 'post',
      data,
    })
}


export function classDetail (data) {
  return request({
    url: '/api/trainClass/classDetail',
    method: 'post',
    data,
  })
}

export function deletes (data) {
    return request({
      url: '/api/trainClass/delete',
      method: 'post',
      data,
    })
}


export function getSignList (data) {
  return request({
    url: '/api/trainClass/getSignList',
    method: 'post',
    data,
  })
}

export function searchCourseClassList (data) {
  return request({
    url: '/api/trainClass/searchCourseClassList',
    method: 'post',
    data,
  })
}

export function courseClassSave (data) {
  return request({
    url: '/api/trainClass/saveOrUpdateCourseClass',
    method: 'post',
    data,
  })
}


export function deleteCourseClass (data) {
  return request({
    url: '/api/trainClass/deleteCourseClass',
    method: 'post',
    data,
  })
}

export function courseClassFileSave (data) {
  return request({
    url: '/api/trainClass/courseClassFileSave',
    method: 'post',
    data,
  })
}

export function courseClassFileDetail (data) {
  return request({
    url: '/api/trainClass/courseClassFileDetail',
    method: 'post',
    data,
  })
}

export function courseClassFileDelete (data) {
  return request({
    url: '/api/trainClass/courseClassFileDelete',
    method: 'post',
    data,
  })
}

// 班级详情
export function searchInfoInit (classId) {
  return request({
    url: '/api/classCourse/searchInit',
    method: 'post',
    params: {classId},
  })
}

export function searchInfoList (data) {
  return request({
    url: '/api/classCourse/searchList',
    method: 'post',
    data,
  })
}

export function infoSave (data) {
  return request({
    url: '/api/classCourse/save',
    method: 'post',
    data,
  })
}
